import React from 'react';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Sarah K.',
    role: 'Product Designer',
    quote: 'Vergo saved me hours of research. I found the perfect AI design tool in minutes.',
    rating: 5,
  },
  {
    name: 'James R.',
    role: 'Software Engineer',
    quote: 'The comparison feature is unmatched. No other directory lets me evaluate tools side-by-side like this.',
    rating: 5,
  },
  {
    name: 'Amira L.',
    role: 'Graduate Student',
    quote: 'As a student on a budget, the free tool filters and honest reviews helped me find exactly what I needed.',
    rating: 5,
  },
];

export const SocialProof: React.FC = () => {
  return (
    <section className="py-20 px-4 border-t border-border">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-12">
          <p className="text-4xl font-bold mb-2">10,000+</p>
          <p className="text-muted-foreground">users trust Vergo to find the right AI tools</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="border border-border rounded-lg p-6 space-y-4">
              <div className="flex gap-0.5">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-foreground text-foreground" />
                ))}
              </div>
              <p className="text-sm leading-relaxed text-foreground">"{t.quote}"</p>
              <div>
                <p className="text-sm font-medium">{t.name}</p>
                <p className="text-xs text-muted-foreground">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
